import { Link } from 'react-router-dom'
import './NotFound.css'

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-icon">404</div>
        <h1 className="not-found-title">Page Not Found</h1>
        <p className="not-found-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="not-found-btn primary">
            <i className="fas fa-home"></i>
            Go to Home
          </Link>
          <Link to="/" className="not-found-btn secondary">
            <i className="fas fa-arrow-left"></i>
            Browse Events
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound

